import React from "react";
import { Table } from "reactstrap";

export default ({ closingTimes }: { closingTimes: ClosingTimesCurrent }) => {
    const { mon, tue, wed, thu, fri, sat, sun } = closingTimes;
    return (
        <Table>
            <thead>
                <tr>
                    <th />
                    <th>M</th>
                    <th>T</th>
                    <th>W</th>
                    <th>T</th>
                    <th>F</th>
                    <th>S</th>
                    <th>S</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th scope="row">Closing Time</th>
                    <td>{mon && mon.closingTime}</td>
                    <td>{tue && tue.closingTime}</td>
                    <td>{wed && wed.closingTime}</td>
                    <td>{thu && thu.closingTime}</td>
                    <td>{fri && fri.closingTime}</td>
                    <td>{sat && sat.closingTime}</td>
                    <td>{sun && sun.closingTime}</td>
                </tr>
                <tr>
                    <th scope="row">Discount Starts</th>
                    <td>{mon && mon.discountStartingTime}</td>
                    <td>{tue && tue.discountStartingTime}</td>
                    <td>{wed && wed.discountStartingTime}</td>
                    <td>{thu && thu.discountStartingTime}</td>
                    <td>{fri && fri.discountStartingTime}</td>
                    <td>{sat && sat.discountStartingTime}</td>
                    <td>{sun && sun.discountStartingTime}</td>
                </tr>
                <tr>
                    <th scope="row">Discount</th>
                    <td>{mon && mon.discountPercent && `${mon.discountPercent}%`}</td>
                    <td>{tue && tue.discountPercent && `${tue.discountPercent}%`}</td>
                    <td>{wed && wed.discountPercent && `${wed.discountPercent}%`}</td>
                    <td>{thu && thu.discountPercent && `${thu.discountPercent}%`}</td>
                    <td>{fri && fri.discountPercent && `${fri.discountPercent}%`}</td>
                    <td>{sat && sat.discountPercent && `${sat.discountPercent}%`}</td>
                    <td>{sun && sun.discountPercent && `${sun.discountPercent}%`}</td>
                </tr>
            </tbody>
        </Table>
    );
};
